import Label from 'components/Label';
import { Heading, P, Section, Wrapper } from 'components/base';
import { Link } from "gatsby";
import PropType from 'prop-types';
import React from 'react';
import GoIcon from 'svgs/icons/go.svg';
import { bContent, bImage, goicon, image, item, links, linktext } from './TwoCols.module.scss';

const Item = ({ heading, content, list, img, link, link2, isNew }) => (
  <div className={item}>
    <div className={bContent}>
      <Heading Tag="h2" size="SL" bold marginBottom="Xxs">
        {isNew && <Label text="New" theme="Yellow" position="before" />}
        {heading}
      </Heading>
      <P Tag="h3">{content}</P>
      {list && <P className="mt-xs">
        <ul className="unordered-list">
          {list.map((item, i) => (
            <li key={i}><P Tag="h3">{item}</P></li>
          ))}
        </ul>
      </P>}
      <div className={links}>
        {link && 
        <div className={linktext}>
          <Link to={link.to}>{link.text}</Link>
          <GoIcon className={goicon} />
        </div>}
        {link2 && 
        <div className={linktext}>
          <Link to={link2.to}>{link2.text}</Link>
          <GoIcon className={goicon} />
        </div>}
      </div>
      
    </div>
    <div className={bImage}>
      <img src={img.publicURL} alt={heading} className={image} />
    </div>
  </div>
);
Item.propTypes = {
  heading: PropType.string.isRequired,
  content: PropType.string.isRequired,
  list: PropType.array,
  img: PropType.shape({
    publicURL: PropType.string,
  }).isRequired,
  link: PropType.shape({
    text: PropType.string.isRequired,
    to: PropType.string.isRequired,
  }),
  link2: PropType.shape({
    text: PropType.string.isRequired,
    to: PropType.string.isRequired,
  }),
  isNew: PropType.bool,
};
Item.defaultProps = {
  heading: "",
  content: "",
  list: null,
  img: null,
  link: null,
  link2: null,
  isNew: false,
}

const TwoCols = ({ data, padding }) => (
  <Section padding={padding}>
    <Wrapper size="ML">
      {data.map((props, i) => (
        <Item {...props} key={i} />
      ))}
    </Wrapper>
  </Section>
);
TwoCols.propTypes = {
  data: PropType.array.isRequired,
  padding: PropType.string.isRequired,
};
TwoCols.defaultProps = {
  padding: 'None',
}

export default TwoCols;
